const socketServerURL = `${process.env.REACT_APP_HOST_URL}`;
const socketPath = `/socket.io`;

export { socketServerURL, socketPath };
